import { Flex } from 'antd';
import PageContainer from '../../common/components/PageContainer';
import { spacing } from '../../theming';
import VinExtractionHeader from '../../components/vinExtraction/VinExtractionHeader';
import VinExtractionNotAllowed from './VinExtractionNotAllowed';

const VinExtractionNotAllowedPage = () => (
    <PageContainer>
        <Flex vertical gap={spacing[3]}>
            <VinExtractionHeader showControls={false} />
            <VinExtractionNotAllowed />
        </Flex>
    </PageContainer>
);

export default VinExtractionNotAllowedPage;
